import { ChevronDown } from "lucide-react";
import { ddmmyyyy, inr } from "../../lib/format";
import { PODetail } from "./PODetail";

export const StatusChip = ({ status, testid }) => <span className={`chip chip-${status}`} data-testid={testid}>{status}</span>;

export const POCard = ({ po, settings, open, onToggle, onChanged }) => {
  const t = `po-card-${po.po_no}`;
  return (
    <div className="panel overflow-hidden scroll-mt-20" data-testid={t} data-po-id={po.id}>
      <button type="button" onClick={onToggle} className="flex w-full items-start gap-3 p-4 text-left transition-colors hover:bg-muted/40"
        data-testid={`${t}-toggle`}>
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="mono font-bold">{po.po_no}</span>
            <StatusChip status={po.status} testid={`${t}-status`} />
            {po.is_sample && <span className="chip border-border text-muted-foreground">Sample</span>}
            {po.source === "link" && <span className="chip border-border text-brand" data-testid={`${t}-via-link`}>Via link</span>}
          </div>
          <p className="truncate font-semibold">{po.vendor.name}</p>
          <p className="text-xs text-muted-foreground">{ddmmyyyy(po.po_date)} · {po.items.length} item{po.items.length === 1 ? "" : "s"}</p>
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1">
          <span className="mono font-bold" data-testid={`${t}-total`}>{inr(po.total)}</span>
          <ChevronDown size={18} className={`text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
        </div>
      </button>
      {open && settings && <PODetail po={po} settings={settings} onChanged={onChanged} testid={t} />}
    </div>
  );
};
